import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { useAppliedFilters } from '../../filters/hooks/useAppliedFilters';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { useSearchParams } from '../../hooks/useSearchParams';
import { SORT_OPTIONS } from '../components/SortDropdown';

// TODO: Remove this after BE fixes leaky abstraction.
const DATA_TYPE_MAP = {
  BOOLEAN: 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery',
  FLOAT: 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery',
  LONG: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery',
  STRING: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery'
};
export function useSearchResultsQuery() {
  const appliedFilters = useAppliedFilters();
  const params = useSearchParams();
  const sort = params.get('sort', {
    allowedValues: SORT_OPTIONS
  });
  return usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      variables: {
        queryType: 'ELASTIC_SEARCH',
        filter: mapAppliedFiltersForRpc(appliedFilters),
        sorts: mapSortForRpc(sort)
      }
    }
  });
}
function mapSortForRpc(sort) {
  switch (sort) {
    case 'MOST_INSTALLED':
      return [{
        field: 'INSTALL_COUNT',
        order: 'DESC'
      }];
    case 'NEWEST':
      return [{
        field: 'FIRST_PUBLISHED_AT',
        order: 'DESC'
      }];
    case 'NAME_AZ':
      return [{
        field: 'LISTING_NAME',
        order: 'ASC'
      }];
    case 'NAME_ZA':
      return [{
        field: 'LISTING_NAME',
        order: 'DESC'
      }];
    default:
      return undefined;
  }
}
function mapAppliedFiltersForRpc(filters) {
  const filtersByField = {};
  for (const filter of filters) {
    filtersByField[filter.field] = [{
      values: filter.values,
      clause: 'OR',
      negation: false,
      __typename: DATA_TYPE_MAP[filter.dataType]
    }];
  }
  return {
    filterGroups: [{
      filtersByField,
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
}